import { useEffect, useState } from "react"

const STEP_DURATION_MS = 4000

export function useEligibilityLoadingSteps(stepCount: number) {
    const [stepIndex, setStepIndex] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
            setStepIndex((previousStepIndex) => (previousStepIndex + 1) % stepCount)
        }, STEP_DURATION_MS)

        return () => clearInterval(timer)
    }, [stepCount])

    return stepIndex
}
